var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_712_5422)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95996 16.7866C7.82663 15.7599 9.91996 14.8933 11.8666 14.0266C15.2266 12.6133 18.5866 11.2133 22 9.91993C22.6666 9.69326 23.8533 9.47993 23.9733 10.4666C23.9066 11.8533 23.6533 13.2399 23.4666 14.6133C23.0133 17.6533 22.48 20.6799 21.96 23.7066C21.7866 24.7199 20.52 25.2399 19.7066 24.5866C17.76 23.2799 15.8133 21.9733 13.8933 20.6399C13.2666 19.9999 13.8533 19.0799 14.4133 18.6266C16.0133 17.0533 17.7066 15.7066 19.2266 14.0533C19.64 13.0666 18.4266 13.8933 18.0266 14.1466C15.84 15.6533 13.7066 17.2533 11.3866 18.5866C10.2133 19.2399 8.82663 18.6799 7.6533 18.3199C6.59996 17.8933 5.0533 17.4533 5.95996 16.7866Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_5422",
    x1: 20.688,
    y1: 5.05827,
    x2: 10.688,
    y2: 28.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSend);
export default __webpack_public_path__ + "static/media/social_send.183fe0196475896c844893182d041042.svg";
export { ForwardRef as ReactComponent };